import React from 'react'
import { Divider, FlowGrid, H3, Row, Separator, Skeleton, Toggle } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import ConclusionContainer from '../../components/ConclusionContainer'

type ConclusionSectionSkeletonProps = {
  heading: string
  isOneColumn: boolean
}

function ConclusionSectionSkeleton({ heading, isOneColumn }: ConclusionSectionSkeletonProps): JSX.Element {
  return (
    <>
      <Row alignY="middle" guttersY="nano">
        <H3 growX size="H5" supplementary>
          {heading}
        </H3>
      </Row>
      <Separator size="nano" />
      <FlowGrid guttersY="nano" orientation="vertical" columnCount={isOneColumn ? 1 : 2}>
        <ConclusionContainer>
          <Skeleton.Paragraph lineCount={2} size="md" />
        </ConclusionContainer>
        <ConclusionContainer>
          <Skeleton.Paragraph lineCount={2} size="md" />
        </ConclusionContainer>
        <ConclusionContainer>
          <Skeleton.Paragraph lineCount={2} size="md" />
        </ConclusionContainer>
      </FlowGrid>
    </>
  )
}

type Props = {
  columns?: number
}

export default function OtherInformationLoading({ columns = 12 }: Props): JSX.Element {
  const [t] = useTranslation()
  const isOneColumn = columns >= 7
  return (
    <>
      <Toggle
        aria-label={t('tree-person.show-contributor-details.label')}
        data-testid="facts-detail-view"
        label={t('tree-person.detail-view.label')}
        disabled
      />
      <Separator size="nano" />
      <ConclusionSectionSkeleton heading={t('tree-person.alternate-names.header')} isOneColumn={isOneColumn} />
      <Divider marginY="xxs" />
      <ConclusionSectionSkeleton heading={t('tree-person.events.header')} isOneColumn={isOneColumn} />
      <Divider marginY="xxs" />
      <ConclusionSectionSkeleton heading={t('tree-person.facts.header')} isOneColumn={isOneColumn} />
      <Separator size="xxs" />
    </>
  )
}
